import React, { useEffect, useState } from "react";
import getOffer from "../api/getOffer";

import OfferForm from "../components/OfferForm";

const Offer = () => {
  const [offer, setOffer] = useState();
  // fetching offer data
  useEffect(() => {
    const fetchOffer = async () => {
      try {
        const data = await getOffer();
        if (data && data.length > 0) {
          const offerData = data[0];
          setOffer(offerData);
        }
      } catch (error) {
        console.error("Failed to fetch offer data:", error);
      }
    };

    fetchOffer();
  }, []);

  return (
    <>
      <section className="body-font relative text-gray-600">
        <div className="container mx-auto flex px-5 py-4">
          <div className="flex w-full flex-col items-end rounded-lg bg-white p-8">
            <h2 className="title-font  text-lg font-medium text-gray-900 mb-4">النص ترويجي</h2>
            {offer ? <OfferForm offer={offer} /> : ""}
          </div>
        </div>
      </section>
    </>
  );
};

export default Offer;
